import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "TrainingType/";

const getTrainingTypeById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetTrainingTypeById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getTrainingTypes = async (showArchived) => await axiosInstance.get(ENDPOINTORIGIN + 'GetTrainingTypes?showArchived=' + showArchived, constants.REQUIRE_INTERCEPTORS);

const saveTrainingType = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveTrainingType', model, constants.REQUIRE_INTERCEPTORS);

const archiveTrainingType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'ArchiveTrainingType?id=' + id, constants.REQUIRE_INTERCEPTORS);

const unarchiveTrainingType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'UnarchiveTrainingType?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getTrainingTypeById,
    getTrainingTypes,
    saveTrainingType,
    archiveTrainingType,
    unarchiveTrainingType
}